import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { buttonSizesList } from './ButtonsBoard';
import { faAdd, faCheck, faExclamation, faXmark } from '@fortawesome/pro-solid-svg-icons';

export interface IconButtonSectionProps { }

export const IconButtonSection: React.FC<IconButtonSectionProps> = ({ }) => {

  return (
    <div className='flex flex-col gap-6'>
      <VoxelText>Primary color</VoxelText>
      <div>
        <div className="w-full flex flex-row gap-3">
          <VoxelIconButton
            color={'primary'}
            icon={<FontAwesomeIcon icon={faAdd} />}
            tooltip='Primary'
          />
        </div>
      </div>
      <VoxelText>Severity colors</VoxelText>
      <div>
        <div className="w-full flex flex-row gap-3">
          <VoxelIconButton
            color={'success'}
            icon={<FontAwesomeIcon icon={faCheck} />}
            tooltip='Success'
          />
          <VoxelIconButton
            color={'warning'}
            icon={<FontAwesomeIcon icon={faExclamation} />}
            tooltip='Warning'
          />
          <VoxelIconButton
            color={'error'}
            icon={<FontAwesomeIcon icon={faXmark} />}
            tooltip='Error'
          />
        </div>
      </div>
      <VoxelText>Other colors</VoxelText>
      <div>
        <div className="w-full flex flex-row gap-3">
          <VoxelIconButton
            color={'transparent'}
            icon={<FontAwesomeIcon icon={faAdd} />}
            tooltip='Transparent'
          />
          <VoxelIconButton
            color={'white'}
            icon={<FontAwesomeIcon icon={faAdd} />}
            tooltip='White'
          />
          <VoxelIconButton
            color={'light-gray'}
            icon={<FontAwesomeIcon icon={faAdd} />}
            tooltip='Light gray'
          />
          <VoxelIconButton
            color={'gray'}
            icon={<FontAwesomeIcon icon={faAdd} />}
            tooltip='Gray'
          />
        </div>
      </div>
      <VoxelText>Sizes</VoxelText>
      <div className="w-fit grid grid-cols-3 gap-y-8 gap-x-6">
        <VoxelText variant="title3" paddingTop>
          xs
        </VoxelText>
        {buttonSizesList.map(b => (
          <VoxelIconButton
            size='xs'
            tooltip={b.title}
            color={b.color}
            icon={<FontAwesomeIcon icon={b.icon} size="sm" />}
          />
        ))}
        <VoxelText variant="title3" paddingTop>
          sm
        </VoxelText>
        {buttonSizesList.map(b => (
          <VoxelIconButton
            size='sm'
            tooltip={b.title}
            color={b.color}
            icon={<FontAwesomeIcon icon={b.icon} />}
          />
        ))}

        <VoxelText variant="title3" paddingTop>
          md
        </VoxelText>
        {buttonSizesList.map(b => (
          <VoxelIconButton
            size='md'
            tooltip={b.title}
            color={b.color}
            icon={<FontAwesomeIcon icon={b.icon} size='lg' />}
          />
        ))}

        <VoxelText variant="title3" paddingTop>
          lg
        </VoxelText>
        {buttonSizesList.map(b => (
          <VoxelIconButton
            size='lg'
            tooltip={b.title}
            color={b.color}
            icon={<FontAwesomeIcon icon={b.icon} size='xl' />}
          />
        ))}

        <VoxelText variant="title3" paddingTop>
          xl
        </VoxelText>
        {buttonSizesList.map(b => (
          <VoxelIconButton
            size='xl'
            tooltip={b.title}
            color={b.color}
            icon={<FontAwesomeIcon icon={b.icon} size='xl' />}
          />
        ))}
      </div>
    </div >
  );
};

export default IconButtonSection;
